import {
    DashboardContentOptions,
    DashboardExperience,
    FrameOptions,
    createEmbeddingContext
} from "amazon-quicksight-embedding-sdk";

export const renderDashboardEmbedUrl = async (
    url: string,
    containerId: string,
    contentOptions?: DashboardContentOptions,
    frameOptions?: FrameOptions
): Promise<DashboardExperience | null> => {
    if (url) {
        const embeddingContext = await createEmbeddingContext();
        const { embedDashboard } = embeddingContext;
        const contentOpts = contentOptions || {};
        const frameOpts = frameOptions || {
            url,
            container: `#${containerId}`,
            height: "100%",
            width: "100%",
            withIframePlaceholder: true,
            resizeHeightOnSizeChangedEvent: true
        };
        const dashboard = await embedDashboard(frameOpts, contentOpts);
        return dashboard;
    }
    return null;
};
